import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Card, message } from 'antd';
import DashboardLayout from '../components/DashboardLayout';
import { useWriteContract } from 'wagmi';
import { CONTRACT_ADDRESS, CONTRACT_ABI } from '../config/contractConfig';
import '../styles/Generate-and-Accept-InviteCode.css';


const InviteCode: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [projectDetails, setProjectDetails] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);

  const { writeContractAsync, isSuccess, isError, isPending } = useWriteContract();
  

  // Extract query params
  const params = new URLSearchParams(location.search);
  const projectId = params.get('projectid');  // Fetch projectId from the query params

  useEffect(() => {
    if (projectId) {
      // Fetch project details based on the projectId (Placeholder data for now)
      setProjectDetails({
        title: 'FigFig - Share and Earn',
        description: 'Join the project and start earning rewards!',
        imageUrl: 'https://via.placeholder.com/300',
        iconUrl: 'https://via.placeholder.com/50',
      });
    } else {
      // Redirect to the dashboard if projectId is missing
      message.error('Invalid promotion link. Redirecting to dashboard...');
      navigate('/dashboard');
    }
  }, [projectId]);

  const handleGenerateInviteCode = async () => {
    if (!projectId) return;

    try {
      setIsLoading(true);

      const tx = await writeContractAsync({
        address: CONTRACT_ADDRESS,
        abi: CONTRACT_ABI,
        functionName: 'createInviteCode',
        args: [projectId],  // Use the projectId to generate the invite code
      });

      if (isPending) {
        console.log('Generating invite code pending:', isPending);
      }

      if (isError) {
        console.log('Generating invite code failed:', isError);
      }

      if (isSuccess) {
        console.log('Invite code successfully generated:', isSuccess);
      }

      message.success('Invite code generated successfully!');
      // You can store the invite code here or display it as needed
    } catch (error) {
      message.error('Failed to generate invite code. Please try again.');
    }
  };

  return (
    <div className="accept-invite-container">
      {/* Upper Half */}
      <div className="accept-invite-upper">
        <img
          src={require('../assets/images/icon.png')}
          alt="Project Icon"
          className="accept-invite-icon"
        />
        <h1 className="accept-invite-title">{projectDetails?.title || 'Loading...'}</h1>
        <p className="accept-invite-subtitle">STARFISH TECHNOLOGY - FZE</p>
        <Button
          type="primary"
          onClick={handleGenerateInviteCode}
          loading={isLoading}
          className="accept-invite-button"
        >
          Generate Invite Code
        </Button>
      </div>

      {/* Lower Half */}
      <div className="accept-invite-lower">
        <img
          src={require('../assets/images/img1.png')}
          alt="Screenshot 1"
          className="accept-invite-screenshot"
        />
        <img
          src={require('../assets/images/img2.png')}
          alt="Screenshot 2"
          className="accept-invite-screenshot"
        />
        <img
          src={require('../assets/images/img3.png')}
          alt="Screenshot 3"
          className="accept-invite-screenshot"
        />
        <img
          src={require('../assets/images/img4.png')}
          alt="Screenshot 4"
          className="accept-invite-screenshot"
        />
      </div>

      {/* Text Section */}
      <div className="accept-invite-text">
        <h2>FigFig - Create and Share</h2>
        <p>
          Generate unique invite codes for your projects and share them with your network.
          Use these codes to invite others and track your campaign’s performance.
        </p>
        <p>
          Easily share the generated codes and invite collaborators, customers, or partners
          to join your project. Start creating and sharing now!
        </p>
      </div>
    </div>
  );
};

export default InviteCode;
